import { makeStyles, styled } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const DrawerWidth = 980;

export const Header = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(3),
  boxShadow: theme.customShadows.drawerHeader,
  zIndex: theme.zIndex.drawerCustomHeader
}));

export const HeaderTitleContainer = styled('div')({
  display: 'flex',
  alignItems: 'center'
});

export const HeaderTitle = styled(Typography)(({ theme }) => ({
  marginRight: theme.spacing(2)
}));

export const LoaderContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%'
});

export const useStyles = makeStyles(theme => ({
  drawerLarge: {
    width: DrawerWidth,
    overflowY: 'hidden',
    [theme.breakpoints.down(1024)]: {
      width: '80%'
    }
  },
  drawerContentContainer: {
    padding: 0,
    backgroundColor: theme.palette.grey[50]
  },
  drawerSection: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(2)
  }
}));
